import { v4 as uuidv4 } from "uuid";
import checkBulletImage from "@circle-react-shared/BuilderUI/Assets/icons/check_bullet_transparent.png";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { bulletStyles } from "@circle-react-shared/BuilderUI/DefaultBlocks/Content/UlListBlock/UlBlockDefaultData";
import { createImageBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/mediaBlockHelpers";
import { getBlockPrimaryStyleOptions } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/stylesHelpers";
import {
  createH2Block,
  createPBlock,
  createUlBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import { getBorderRadiusOptions } from "@circle-react-shared/BuilderUI/utils/imgStyleHelpers";
import { getSizingOptions } from "@circle-react-shared/BuilderUI/utils/sizeStyleHelpers";
import { getTextTransformOptions } from "@circle-react-shared/BuilderUI/utils/textStyleHelpers";
import placeholderImage from "./homepage_block_3_default_image.png";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "EvergreenHomepageBlock3",
  props: {
    leftContent: {
      prop: "children",
      type: "children",
      value: [
        createImageBlock({
          signedId: "",
          placeholder: placeholderImage,
          styles: {
            sizing: getSizingOptions({
              defaultValue: {
                maxHeight: "none",
                maxWidth: "none",
                width: "100%",
                height: "100%",
                minHeight: "auto",
                minWidth: "auto",
              },
            }),
            borderRadius: getBorderRadiusOptions({
              defaultValue: {
                border_left_top_radius: 20,
                border_left_bottom_radius: 20,
                border_right_top_radius: 20,
                border_right_bottom_radius: 20,
              },
            }),
          },
        }),
      ],
    },
    rightContent: {
      prop: "children",
      type: "children",
      value: [
        createPBlock({
          text: "About us",
          paragraphStyle: "p3",
          styles: {
            textTransform: getTextTransformOptions("uppercase"),
          },
        }),
        createH2Block({
          text: "Where vision becomes curriculum",
        }),
        createPBlock({
          text: "We built Elevate Academy for creators and educators ready to teach with intention and grow with structure. No shortcuts. No chaos. Just real frameworks, strategic design, and community that keeps you moving forward.",
        }),
        createUlBlock({
          items: [
            {
              text: "Educators evolving into course entrepreneurs",
              placeholder: checkBulletImage,
              bulletStyles,
            },
            {
              text: "Creators who want to teach with clarity",
              placeholder: checkBulletImage,
              bulletStyles,
            },
            {
              text: "Solopreneurs scaling with structure—not hustle",
              placeholder: checkBulletImage,
              bulletStyles,
            },
          ],
        }),
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        ...getBlockPrimaryStyleOptions(),
      },
    },
  },
};
